const { createAction } = require('../helpers')
const {
  GET_CAMPAIGN_LIST,
  GET_CAMPAIGN_LIST_SUCCESS,
  GET_CAMPAIGN_LIST_ERROR,
  GET_CAMPAIGN_LIST_RESET,

  CREATE_CAMPAIGN,
  CREATE_CAMPAIGN_SUCCESS,
  CREATE_CAMPAIGN_ERROR,
  CREATE_CAMPAIGN_RESET,

  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_ERROR,
  UPDATE_CAMPAIGN_RESET,

  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_ERROR,
  DELETE_CAMPAIGN_RESET,

  GET_ROUTE_LIST,
  GET_ROUTE_LIST_SUCCESS,
  GET_ROUTE_LIST_ERROR,
  GET_ROUTE_LIST_RESET,

  CREATE_ROUTE,
  CREATE_ROUTE_SUCCESS,
  CREATE_ROUTE_ERROR,
  CREATE_ROUTE_RESET,

  UPDATE_ROUTE,
  UPDATE_ROUTE_SUCCESS,
  UPDATE_ROUTE_ERROR,
  UPDATE_ROUTE_RESET,

  DELETE_ROUTE,
  DELETE_ROUTE_SUCCESS,
  DELETE_ROUTE_ERROR,
  DELETE_ROUTE_RESET,

  DO_TEST_AUDIO_CALL,
  DO_TEST_AUDIO_CALL_SUCCESS,
  DO_TEST_AUDIO_CALL_ERROR,
  DO_TEST_AUDIO_CALL_RESET,

  GET_PRIORITY_TEAM_LIST,
  GET_PRIORITY_TEAM_LIST_SUCCESS,
  GET_PRIORITY_TEAM_LIST_ERROR,
  GET_PRIORITY_TEAM_LIST_RESET,

  GET_PRIORITY_TEAM_DETAIL,
  GET_PRIORITY_TEAM_DETAIL_SUCCESS,
  GET_PRIORITY_TEAM_DETAIL_ERROR,
  GET_PRIORITY_TEAM_DETAIL_RESET,

  CREATE_PRIORITY_TEAM,
  CREATE_PRIORITY_TEAM_SUCCESS,
  CREATE_PRIORITY_TEAM_ERROR,
  CREATE_PRIORITY_TEAM_RESET,

  UPDATE_PRIORITY_TEAM,
  UPDATE_PRIORITY_TEAM_SUCCESS,
  UPDATE_PRIORITY_TEAM_ERROR,
  UPDATE_PRIORITY_TEAM_RESET,

  ADD_DOCTOR_TO_PRIORITY_TEAM,
  ADD_DOCTOR_TO_PRIORITY_TEAM_SUCCESS,
  ADD_DOCTOR_TO_PRIORITY_TEAM_ERROR,
  ADD_DOCTOR_TO_PRIORITY_TEAM_RESET,

  DELETE_PRIORITY_TEAM,
  DELETE_PRIORITY_TEAM_SUCCESS,
  DELETE_PRIORITY_TEAM_ERROR,
  DELETE_PRIORITY_TEAM_RESET,

} = require('./constants')

// eslint-disable-next-line max-len
const getCampaignList = ({ search }) => createAction(GET_CAMPAIGN_LIST, { search })
const getCampaignListSuccess = data => createAction(GET_CAMPAIGN_LIST_SUCCESS, { data })
const getCampaignListError = error => createAction(GET_CAMPAIGN_LIST_ERROR, { error })
const getCampaignListReset = () => createAction(GET_CAMPAIGN_LIST_RESET)

const createCampaign = campaignData => createAction(CREATE_CAMPAIGN, { campaignData })
const createCampaignSuccess = data => createAction(CREATE_CAMPAIGN_SUCCESS, { data })
const createCampaignError = error => createAction(CREATE_CAMPAIGN_ERROR, { error })
const createCampaignReset = () => createAction(CREATE_CAMPAIGN_RESET)

const updateCampaign = ({ id, campaignData }) => createAction(UPDATE_CAMPAIGN, { id, campaignData })
const updateCampaignSuccess = data => createAction(UPDATE_CAMPAIGN_SUCCESS, { data })
const updateCampaignError = error => createAction(UPDATE_CAMPAIGN_ERROR, { error })
const updateCampaignReset = () => createAction(UPDATE_CAMPAIGN_RESET)

const deleteCampaign = ({ id }) => createAction(DELETE_CAMPAIGN, { id })
const deleteCampaignSuccess = data => createAction(DELETE_CAMPAIGN_SUCCESS, { data })
const deleteCampaignError = error => createAction(DELETE_CAMPAIGN_ERROR, { error })
const deleteCampaignReset = () => createAction(DELETE_CAMPAIGN_RESET)

// eslint-disable-next-line max-len
const getRouteList = () => createAction(GET_ROUTE_LIST)
const getRouteListSuccess = data => createAction(GET_ROUTE_LIST_SUCCESS, { data })
const getRouteListError = error => createAction(GET_ROUTE_LIST_ERROR, { error })
const getRouteListReset = () => createAction(GET_ROUTE_LIST_RESET)

const createRoute = routeData => createAction(CREATE_ROUTE, { routeData })
const createRouteSuccess = data => createAction(CREATE_ROUTE_SUCCESS, { data })
const createRouteError = error => createAction(CREATE_ROUTE_ERROR, { error })
const createRouteReset = () => createAction(CREATE_ROUTE_RESET)

const updateRoute = ({ id, routeData }) => createAction(UPDATE_ROUTE, { id, routeData })
const updateRouteSuccess = data => createAction(UPDATE_ROUTE_SUCCESS, { data })
const updateRouteError = error => createAction(UPDATE_ROUTE_ERROR, { error })
const updateRouteReset = () => createAction(UPDATE_ROUTE_RESET)

const deleteRoute = ({ id }) => createAction(DELETE_ROUTE, { id })
const deleteRouteSuccess = data => createAction(DELETE_ROUTE_SUCCESS, { data })
const deleteRouteError = error => createAction(DELETE_ROUTE_ERROR, { error })
const deleteRouteReset = () => createAction(DELETE_ROUTE_RESET)

const doTestAudioCall = callData => createAction(DO_TEST_AUDIO_CALL, { callData })
const doTestAudioCallSuccess = data => createAction(DO_TEST_AUDIO_CALL_SUCCESS, { data })
const doTestAudioCallError = error => createAction(DO_TEST_AUDIO_CALL_ERROR, { error })
const doTestAudioCallReset = () => createAction(DO_TEST_AUDIO_CALL_RESET)

const getPriorityTeamList = ({ search }) => createAction(GET_PRIORITY_TEAM_LIST, { search })
const getPriorityTeamListSuccess = data => createAction(GET_PRIORITY_TEAM_LIST_SUCCESS, { data })
const getPriorityTeamListError = error => createAction(GET_PRIORITY_TEAM_LIST_ERROR, { error })
const getPriorityTeamListReset = () => createAction(GET_PRIORITY_TEAM_LIST_RESET)

const getPriorityTeamDetail = id => createAction(GET_PRIORITY_TEAM_DETAIL, { id })
const getPriorityTeamDetailSuccess = data => createAction(GET_PRIORITY_TEAM_DETAIL_SUCCESS, { data })
const getPriorityTeamDetailError = error => createAction(GET_PRIORITY_TEAM_DETAIL_ERROR, { error })
const getPriorityTeamDetailReset = () => createAction(GET_PRIORITY_TEAM_DETAIL_RESET)

const createPriorityTeam = teamData => createAction(CREATE_PRIORITY_TEAM, { teamData })
const createPriorityTeamSuccess = data => createAction(CREATE_PRIORITY_TEAM_SUCCESS, { data })
const createPriorityTeamError = error => createAction(CREATE_PRIORITY_TEAM_ERROR, { error })
const createPriorityTeamReset = () => createAction(CREATE_PRIORITY_TEAM_RESET)

const updatePriorityTeam = ({ id, teamData }) => createAction(UPDATE_PRIORITY_TEAM, { id, teamData })
const updatePriorityTeamSuccess = data => createAction(UPDATE_PRIORITY_TEAM_SUCCESS, { data })
const updatePriorityTeamError = error => createAction(UPDATE_PRIORITY_TEAM_ERROR, { error })
const updatePriorityTeamReset = () => createAction(UPDATE_PRIORITY_TEAM_RESET)

const addDoctorToPriorityTeam = ({ id, doctorsData }) => createAction(ADD_DOCTOR_TO_PRIORITY_TEAM, { id, doctorsData })
const addDoctorToPriorityTeamSuccess = data => createAction(ADD_DOCTOR_TO_PRIORITY_TEAM_SUCCESS, { data })
const addDoctorToPriorityTeamError = error => createAction(ADD_DOCTOR_TO_PRIORITY_TEAM_ERROR, { error })
const addDoctorToPriorityTeamReset = () => createAction(ADD_DOCTOR_TO_PRIORITY_TEAM_RESET)

const deletePriorityTeam = id => createAction(DELETE_PRIORITY_TEAM, { id })
const deletePriorityTeamSuccess = data => createAction(DELETE_PRIORITY_TEAM_SUCCESS, { data })
const deletePriorityTeamError = error => createAction(DELETE_PRIORITY_TEAM_ERROR, { error })
const deletePriorityTeamReset = () => createAction(DELETE_PRIORITY_TEAM_RESET)

module.exports = {
  getCampaignList,
  getCampaignListSuccess,
  getCampaignListError,
  getCampaignListReset,
  createCampaign,
  createCampaignSuccess,
  createCampaignError,
  createCampaignReset,
  updateCampaign,
  updateCampaignSuccess,
  updateCampaignError,
  updateCampaignReset,
  deleteCampaign,
  deleteCampaignSuccess,
  deleteCampaignError,
  deleteCampaignReset,
  getRouteList,
  getRouteListSuccess,
  getRouteListError,
  getRouteListReset,
  createRoute,
  createRouteSuccess,
  createRouteError,
  createRouteReset,
  updateRoute,
  updateRouteSuccess,
  updateRouteError,
  updateRouteReset,
  deleteRoute,
  deleteRouteSuccess,
  deleteRouteError,
  deleteRouteReset,
  doTestAudioCall,
  doTestAudioCallSuccess,
  doTestAudioCallError,
  doTestAudioCallReset,

  getPriorityTeamList,
  getPriorityTeamListSuccess,
  getPriorityTeamListError,
  getPriorityTeamListReset,

  getPriorityTeamDetail,
  getPriorityTeamDetailSuccess,
  getPriorityTeamDetailError,
  getPriorityTeamDetailReset,

  createPriorityTeam,
  createPriorityTeamSuccess,
  createPriorityTeamError,
  createPriorityTeamReset,

  updatePriorityTeam,
  updatePriorityTeamSuccess,
  updatePriorityTeamError,
  updatePriorityTeamReset,

  addDoctorToPriorityTeam,
  addDoctorToPriorityTeamSuccess,
  addDoctorToPriorityTeamError,
  addDoctorToPriorityTeamReset,

  deletePriorityTeam,
  deletePriorityTeamSuccess,
  deletePriorityTeamError,
  deletePriorityTeamReset,
}
